import { Button } from '@odekoteam/doppio';
import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { refreshRouteData } from 'src/state/slices/delivery/getRoutes';

export default function RouteLoadError(): JSX.Element | null {
  const {
    routesError,
    routesLoading,
    selectedWarehouseId,
    nightEnd,
    deliveryStatuses,
    deliveryPrimaryStatuses,
  } = useAppSelector((state) => state.delivery);
  const dispatch = useAppDispatch();
  if (
    (!routesError &&
      !deliveryStatuses.error &&
      !deliveryPrimaryStatuses.error) ||
    routesLoading
  )
    return null;
  return (
    <RouteLoadErrorMessage
      isDisabled={!selectedWarehouseId || !nightEnd.viewing}
      onRetry={(): void => {
        dispatch(refreshRouteData());
      }}
    />
  );
}

export function RouteLoadErrorMessage({
  onRetry,
  isDisabled = false,
}: {
  onRetry: () => void;
  isDisabled?: boolean;
}): JSX.Element {
  return (
    <div role="alert" sx={{ padding: '12px', backgroundColor: 'background' }}>
      <p>Route data could not be loaded.</p>
      <Button variant="secondary" isDisabled={isDisabled} onPress={onRetry}>
        Retry routes
      </Button>
    </div>
  );
}
